"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const assert = require('assert').strict;
exports.resolveExpression = (expression, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    const { resolvers } = context;
    const matchingResolver = resolvers.find(({ accepts }) => accepts(expression));
    if (!matchingResolver) {
        throw new Error(`No resolver defined for ${expression}`);
    }
    const { resolve } = matchingResolver;
    return resolve(expression, context);
});
//# sourceMappingURL=evaluate.js.map